import { Component} from '@angular/core';
import { PAGINA_HOME } from '../../tools/URL'

@Component({
  selector: 'sucesso',
  templateUrl: './sucesso.component.html',
  styleUrls: ['./sucesso.component.css']
})
export class SucessoComponent {
  home = PAGINA_HOME;
}
